<template>
    <div class="relative-position"
        :class="{ active: showShareOptions }"
        id="share-button">

        <q-btn flat
            @click="showShareOptions = !showShareOptions"
            class="icon-wrapper"
            :class="{ active: showShareOptions }">
                <span class="icon share"></span>
                <q-tooltip anchor="top middle" self="bottom middle">
                    <p>Поделиться</p>
                </q-tooltip>
        </q-btn>

        <div v-if="showShareOptions" class="q-tooltip--style q-tooltip--style-advanced">
            <a @click.prevent="share('vk')" :href="link('vk')" class="product-share-link">
                <span class="icon social-vk" />
            </a>
            <a @click.prevent="share('od')" :href="link('od')" class="product-share-link">
                <span class="icon social-od" />
            </a>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        url: {
            type: String,
            required: false,
        },
        iconOnly: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            showShareOptions: false,
            position: 'bottom',
            modal: false,
            socialLinks: {
                'vk': 'https://vkontakte.ru/share.php?url=',
                'od': 'https://connect.ok.ru/offer?url=',
                'fb': 'https://www.facebook.com/sharer.php?u=',
                'tw': 'https://twitter.com/share?url='
            }
        }
    },
    mounted() {
        let _this = this;

        let ignoreClickOnMeElement = document.getElementById('share-button');

        document.addEventListener('click', function (event) {
            if ((ignoreClickOnMeElement !== event.target) && !ignoreClickOnMeElement.contains(event.target)) {
                _this.showShareOptions = false;
            }
        });
    },
    methods: {
        link(slug) {
            return this.socialLinks[slug] + (this.url ? this.url : window.location.href);
        },
        share(slug) {
            window.open(this.link(slug), '', 'status = 1, height = 500, width = 560, resizable = 0');
        }
    }
}
</script>
